import React from 'react';

import { Stack } from '@atlaskit/primitives/compiled';

import { Attribution } from '@confluence/error-boundary/entry-points/Attribution';
import { withErrorBoundary } from '@confluence/error-boundary/entry-points/withErrorBoundary';
import { useContentType } from '@confluence/page-context';
import { ScreenEvent } from '@confluence/analytics/entry-points/ScreenEvent';
import { SIDEBAR_DETAILS_PANEL_LOAD_EXPERIENCE } from '@confluence/experience-tracker/entry-points/ExperienceName';
import { ExperienceSuccess } from '@confluence/experience-tracker/entry-points/component';

import { PeopleSection } from './components/PeopleSection';
import { StatsSection } from './components/StatsSection';
import { InfoSection } from './components/InfoSection';
// eslint-disable-next-line import/no-cycle
import { ConnectionsSection } from './components/ConnectionsSection';
import { useElementVisibility, ELEMENTS } from './hooks/useIsElementVisible';

type DetailsPanelComponentProps = {
	highlightLabels?: boolean;
};

const DetailsPanelComponent = ({ highlightLabels }: DetailsPanelComponentProps) => {
	const { isElementVisible } = useElementVisibility();
	const [contentType] = useContentType();

	return (
		<>
			<Stack testId="details-panel-body">
				<PeopleSection />
				<StatsSection />
				{isElementVisible(ELEMENTS.SECTIONS.PROPERTIES) && (
					<InfoSection highlightLabels={highlightLabels} />
				)}
				{isElementVisible(ELEMENTS.SECTIONS.CONNECTIONS) && <ConnectionsSection />}
			</Stack>
			<ExperienceSuccess name={SIDEBAR_DETAILS_PANEL_LOAD_EXPERIENCE} />
			<ScreenEvent
				name="detailsPanelScreen"
				id="detailsPanelScreen"
				attributes={{ contentType, isOpenedFromFooterLabels: highlightLabels }}
			/>
		</>
	);
};

export const DetailsPanelBody = withErrorBoundary({
	attribution: Attribution.DISCO,
})(DetailsPanelComponent);
